export const LOCAL_WITHDRAWAL_UPDATED_EVENT = "materialentnahme:local-withdrawal-updated";

export type LocalWithdrawalUpdateReason =
  | "draft_saved"
  | "draft_syncing"
  | "draft_synced"
  | "draft_pending"
  | "draft_error"
  | "background_draft_synced";

export interface LocalWithdrawalUpdatedDetail {
  clientUuid: string;
  contentRevision: number;
  reason: LocalWithdrawalUpdateReason;
}

export function dispatchLocalWithdrawalUpdated(
  clientUuid: string,
  contentRevision: number | null | undefined,
  reason: LocalWithdrawalUpdateReason,
): void {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent<LocalWithdrawalUpdatedDetail>(LOCAL_WITHDRAWAL_UPDATED_EVENT, {
    detail: {
      clientUuid,
      contentRevision: Math.max(0, contentRevision ?? 0),
      reason,
    },
  }));
}
